import Utils from '../services/Utils.js';

class ErrorHandler {

  constructor(controller, translationService) {

    this.controller = controller;
    this.translationService = translationService;

  }

  bindErrorsToForm(error) {

    let newState = {};

    switch (error.name) {

      case 'ServerError':
        newState.formError = [this.translationService.get('error.networkfailure')];
        break;

      case 'AuthenticationServiceError':
        newState.formError = [this.translationService.get('error.invalidcredentials')];
        break;

      case 'ServiceError':
        let response = error.getResponse();

        if (accountBlockedErrorFoundInResponse(response)) {
          return this.controller.showBlockedAccountPage();
        } else if (accountLockedErrorFoundInResponse(response)) {
          return this.controller.showLockedAccountPage();
        }

        buildFormFieldErrorMessages.bind(this)(newState, response.field_messages);

        if (Utils.objectIsEmpty(newState)) {
          newState.formError = [getTranslationForErrorCode.bind(this)(response)];
        } else if (newState.formError instanceof Array) {
          newState.formError.unshift(getTranslationForErrorCode.bind(this)(response));
        }
        break;

      default:
        throw error;
    }

    resetUnErroredFields(newState);

    this.controller.setState(newState);
    this.controller.stopActionInProgress();

  }

}

let buildFormFieldErrorMessages = function (state, fieldMessages) {

  let _this = this;

  fieldMessages.forEach(function (fieldMessage) {

    switch(fieldMessage.field) {
      case 'email_address':
        this.emailAddressErrorMessage = getTranslationForErrorCode.bind(_this)(fieldMessage);
        break;
      case 'password':
        this.passwordErrorMessage = getTranslationForErrorCode.bind(_this)(fieldMessage);
        break;
      default:
        if (typeof fieldMessage.error_code !== 'undefined') {
          if (typeof this.formError === 'undefined') {
            this.formError = [];
          }
          this.formError.push(getTranslationForErrorCode.bind(_this)(fieldMessage));
        }
        break;
    }

  }, state);

};

let getTranslationForErrorCode = function (errorCodeContainer) {

  return this.translationService.get(`error.${errorCodeContainer.error_code}`);

};

let resetUnErroredFields = function (state) {

  if (state.formError === undefined) {
    state.formError = undefined;
  }
  if (state.emailAddressErrorMessage === undefined) {
    state.emailAddressErrorMessage = undefined;
  }
  if (state.passwordErrorMessage === undefined) {
    state.passwordErrorMessage = undefined;
  }

};

let accountBlockedErrorFoundInResponse = function (response) {

  return checkErrorsForResponseType(response, 25109);

};

let accountLockedErrorFoundInResponse = function (response) {

  return checkErrorsForResponseType(response, 25110);

};

let checkErrorsForResponseType = function (response, code) {

  let errorFound = false;

  response.field_messages.forEach(function (fieldMessage) {
    if (fieldMessage.error_code === code) {
      errorFound = true;
    }
  });

  return errorFound;

};

export default ErrorHandler;
